import { useTenantApi } from '@/account/hook/useTenantApi';
import { useTenantRoute } from '@/account/hook/useTenantRoute';
import { loadGTMKey } from '@/api/registration/gtm';
import { useQuery } from '@tanstack/react-query';

interface Window {
  dataLayer: any[]
}

declare let window: Window & typeof globalThis;

export const tenantGTMQueryKey = 'tenantGTM';

const useGTM = () => {
  const { tenant, isLoading } = useTenantRoute();
  const { createTenantApiRequest } = useTenantApi();

  const sendGTMEvent = (eventName: string, eventData: Record<string, any>) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: eventName,
        ...eventData,
      });
    }
  };

  const tenantGTMQuery = useQuery(
    [tenantGTMQueryKey, { tenantId: tenant?.id }],
    async () => {
      if (tenant?.id === undefined) {
        throw new Error('Tenant ID is undefined');
      }
      return await loadGTMKey(createTenantApiRequest)({ tenantId: tenant.id });
    },
    {
      enabled: !!tenant?.id && !isLoading,
      retry: false,
    }
  );

  return {
    sendGTMEvent,
    ...tenantGTMQuery,
  };
};

export default useGTM;
